<template>
    <b-notification
        v-if="$parent.statusMessage"
        :type="type"
        :closable="false"
        v-html="$parent.statusMessage"
    />
</template>

<script>
export default {
    computed: {
        type: function() {
            return (this.$parent.statusType === 'error' ? 'is-danger' : 'is-warning');
        },
    },
};
</script>
